(function (){
    'use strict';

    angular
        .module('services')
        .service('PartnerCampaignMediumService', PartnerCampaignMediumService);

    PartnerCampaignMediumService.$inject = ['$http', 'API_BASE'];

    function PartnerCampaignMediumService ($http, API_BASE) {
        var service = this;

        service.getPartnersCampaignMedium = getPartnersCampaignMedium;

        function getPartnersCampaignMedium() {
            return $http.get(API_BASE + '/partners/campaign_medium/list');
        }
    }
})();